import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material';
import { AuthService } from '../modules/service/auth.service';
import { ResetPinComponent } from '../modules/dialogs/reset-pin/reset-pin.component';
import swal from 'sweetalert2';

@Component({
  selector: 'app-login',
  templateUrl: './holl-login.component.html',
  styleUrls: ['./holl-login.component.scss']
})
export class HollLoginComponent implements OnInit {

  payload = {
    identifier: '',   // email or phone
    password: ''
  };

  showPassword = false;
  isLoading = false;
  errorMessage = '';

  constructor(
    private router: Router,
    private auth: AuthService,
    public dialog: MatDialog
  ) { }

  ngOnInit() { }

  togglePassword() {
    this.showPassword = !this.showPassword;
  }

  login(event: Event) {
    event.preventDefault();
    this.errorMessage = '';

    const { identifier, password } = this.payload;

    if (!identifier.trim()) {
      this.errorMessage = 'Please enter your email or mobile number.';
      return;
    }
    if (!password) {
      this.errorMessage = 'Please enter your password.';
      return;
    }

    this.isLoading = true;

    this.auth.login({ email: identifier.trim(), password: password }).subscribe(
      (res) => {
        this.isLoading = false;

        if (res.responseCode === '000') {
          // Pass verified email + original identifier to the OTP page via router state.
          // identifier may be a phone number — the OTP page uses it to show maskedPhone.
          this.router.navigate(['verify-otp'], {
            state: {
              email:      res.email || identifier.trim(),
              identifier: identifier.trim()
            }
          });
        } else {
          this.errorMessage = res.responseMessage || 'Invalid credentials. Please try again.';
        }
      },
      (err) => {
        this.isLoading = false;
        const serverMsg = err && err.error && err.error.responseMessage
          ? err.error.responseMessage
          : 'Login failed. Please check your credentials and try again.';
        this.errorMessage = serverMsg;
      }
    );
  }

  openResetPinDialog() {
    this.dialog.open(ResetPinComponent, {
      disableClose: true,
      width: '300px',
      data: { module: '' }
    });
  }

  goToResetPassword() {
    this.router.navigate(['reset-password']);
  }
}